export enum Features {
  DashboardScreen = 'DashboardScreen',
  TestingToolScreen = 'TestingToolScreen',
  SemanticCacheEditScreen = 'SemanticCacheEditScreen',
  AmwayProductsCatalogScreen = 'AmwayProductsCatalogScreen',
  ResponsesReportScreen = 'ResponsesReportScreen',
  FeedbackReportScreen = 'FeedbackReportScreen',
}
